export default __webpack_public_path__ + "static/media/publish-icon.a23855b2.svg";